import { clientApi2, get, post, put, remove } from '@api';
import { Store } from 'react-notifications-component';
import {
  COMMON_DATA_DELETE_FAIL,
  COMMON_DATA_DELETE_SUCCESS,
  COMMON_DATA_UPDATE_FAIL,
  COMMON_DATA_UPDATE_SUCCESS
} from '../../constants/notification-settings';

export const IMPORT_DATA_CLEAR = 'IMPORT_DATA_CLEAR';
export const IMPORT_DATA_SET_CURRENT_STEP = 'IMPORT_DATA_SET_CURRENT_STEP';
export const IMPORT_DATA_SET_DETECT_BACK_STEP = 'IMPORT_DATA_SET_DETECT_BACK_STEP';
export const IMPORT_DATA_SET_INFO_DATA = 'IMPORT_DATA_SET_INFO_DATA';
export const IMPORT_DATA_SET_OUTPUT_CONFIG = 'IMPORT_DATA_SET_OUTPUT_CONFIG';
export const IMPORT_DATA_SET_IMPORT_CONFIG = 'IMPORT_DATA_SET_IMPORT_CONFIG';
export const IMPORT_DATA_INIT_WORKER = 'IMPORT_DATA_INIT_WORKER';
export const IMPORT_DATA_SET_WORKER_STATUS = 'IMPORT_DATA_SET_WORKER_STATUS';
export const IMPORT_DATA_UPDATE_TABLE_DATA = 'IMPORT_DATA_UPDATE_TABLE_DATA';
export const IMPORT_DATA_UPDATE_PROGRESS = 'IMPORT_DATA_UPDATE_PROGRESS';
export const IMPORT_DATA_UPDATE_UPLOAD_STATUS = 'IMPORT_DATA_UPDATE_UPLOAD_STATUS';
export const IMPORT_DATA_SET_FILE_DATA = 'IMPORT_DATA_SET_FILE_DATA';
export const IMPORT_DATA_SET_GROUP_DATA = 'IMPORT_DATA_SET_GROUP_DATA';
export const IMPORT_DATA_SET_IMPORT_CONFIG_GROUP_RAW_DATA = 'IMPORT_DATA_SET_IMPORT_CONFIG_GROUP_RAW_DATA';
export const IMPORT_DATA_SET_IMPORT_CONFIG_GROUPS = 'IMPORT_DATA_SET_IMPORT_CONFIG_GROUPS';
export const IMPORT_DATA_SET_SELECTED_TEMPLATE_ID = 'IMPORT_DATA_SET_SELECTED_TEMPLATE_ID';
export const IMPORT_DATA_FETCH_ALL_TEMPLATES_START = 'IMPORT_DATA_FETCH_ALL_TEMPLATES_START';
export const IMPORT_DATA_FETCH_ALL_TEMPLATES_SUCCESS = 'IMPORT_DATA_FETCH_ALL_TEMPLATES_SUCCESS';
export const IMPORT_DATA_TEMPLATE_OPERATION_FAIL = 'IMPORT_DATA_TEMPLATE_OPERATION_FAIL';
export const IMPORT_DATA_SET_ERROR = 'IMPORT_DATA_SET_ERROR';
export const IMPORT_DATA_SET_TEMPLATE_SAVE_BLOCK = 'IMPORT_DATA_SET_TEMPLATE_SAVE_BLOCK';
export const IMPORT_DATA_DELETE_TEMPLATE_SUCCESS = 'IMPORT_DATA_DELETE_TEMPLATE_SUCCESS';
export const IMPORT_DATA_SET_IMPORT_WITH_TEMPLATES_STATUS = 'IMPORT_DATA_SET_IMPORT_WITH_TEMPLATES_STATUS';
export const IMPORT_DATA_SET_XML_TEMPLATE_CONFIG = 'IMPORT_DATA_SET_XML_TEMPLATE_CONFIG';
export const IMPORT_DATA_SET_XML_PARSED_DATA = 'IMPORT_DATA_SET_XML_PARSED_DATA';
export const IMPORT_DATA_SET_XML_STRUCTURE = 'IMPORT_DATA_SET_XML_STRUCTURE';
export const IMPORT_DATA_SET_XML_DATA = 'IMPORT_DATA_SET_XML_DATA';
export const IMPORT_DATA_SET_FILES = 'IMPORT_DATA_SET_FILES';
export const IMPORT_DATA_SET_ADDITIONAL_FILES = 'IMPORT_DATA_SET_ADDITIONAL_FILES';
export const IMPORT_DATA_SET_EDITING_TEMPLATE = 'IMPORT_DATA_SET_EDITING_TEMPLATE';

export const importDataClear = () => ({
  type: IMPORT_DATA_CLEAR,
  payload: null
});

export const importDataSetXmlStructure = (payload) => ({
  type: IMPORT_DATA_SET_XML_STRUCTURE,
  payload
});

export const importDataSetXmlParsedData = (payload) => ({
  type: IMPORT_DATA_SET_XML_PARSED_DATA,
  payload
});

export const importDataSetXmlData = (payload) => ({
  type: IMPORT_DATA_SET_XML_DATA,
  payload
});

export const importDataSetFiles = (payload) => ({
  type: IMPORT_DATA_SET_FILES,
  payload
});

export const importDataSetAdditionalFiles = (payload) => ({
  type: IMPORT_DATA_SET_ADDITIONAL_FILES,
  payload
});

export const importDataSetCurrentStep = (payload) => ({
  type: IMPORT_DATA_SET_CURRENT_STEP,
  payload
});

export const importDataSetDetectBackStep = (payload) => ({
  type: IMPORT_DATA_SET_DETECT_BACK_STEP,
  payload
});

export const importDataUpdateTableData = (payload) => ({
  type: IMPORT_DATA_UPDATE_TABLE_DATA,
  payload
});

export const importDataSetInfoData = (payload) => ({
  type: IMPORT_DATA_SET_INFO_DATA,
  payload
});

export const importDataSetOutputConfig = (payload) => ({
  type: IMPORT_DATA_SET_OUTPUT_CONFIG,
  payload
});

export const importDataSetImportConfig = (payload) => ({
  type: IMPORT_DATA_SET_IMPORT_CONFIG,
  payload
});

export const importDataSetImportConfigGroups = (payload) => ({
  type: IMPORT_DATA_SET_IMPORT_CONFIG_GROUPS,
  payload
});

export const importDataSetImportConfigGroupRawData = (payload) => ({
  type: IMPORT_DATA_SET_IMPORT_CONFIG_GROUP_RAW_DATA,
  payload
});

export const importDataSetSelectedTemplateId = (payload) => ({
  type: IMPORT_DATA_SET_SELECTED_TEMPLATE_ID,
  payload
});

export const importDataInitWorker = (payload) => ({
  type: IMPORT_DATA_INIT_WORKER,
  payload
});

export const importDataSetWorkerStatus = (payload) => ({
  type: IMPORT_DATA_SET_WORKER_STATUS,
  payload
});

export const importDataSetProgress = (payload) => ({
  type: IMPORT_DATA_UPDATE_PROGRESS,
  payload
});

export const importDataSetUploadStatus = (payload) => ({
  type: IMPORT_DATA_UPDATE_UPLOAD_STATUS,
  payload
});

export const importDataSetFileData = (payload) => ({
  type: IMPORT_DATA_SET_FILE_DATA,
  payload
});

export const importDataSetGroupData = (payload) => ({
  type: IMPORT_DATA_SET_GROUP_DATA,
  payload
});

export const importDataFetchTemplatesStart = () => ({
  type: IMPORT_DATA_FETCH_ALL_TEMPLATES_START
});

export const importDataFetchTemplatesSuccess = (data) => ({
  type: IMPORT_DATA_FETCH_ALL_TEMPLATES_SUCCESS,
  payload: data
});

export const importDataTemplateOperationFail = (error) => ({
  type: IMPORT_DATA_TEMPLATE_OPERATION_FAIL,
  payload: error
});

export const importDataSetError = (payload) => ({
  type: IMPORT_DATA_SET_ERROR,
  payload
});

export const importDataDeleteTemplateSuccess = () => ({
  type: IMPORT_DATA_DELETE_TEMPLATE_SUCCESS
});

export const importDataSetImportWithTemplatesStatus = (payload) => ({
  type: IMPORT_DATA_SET_IMPORT_WITH_TEMPLATES_STATUS,
  payload
});

export const importDataSetXmlTemplateConfig = (payload) => ({
  type: IMPORT_DATA_SET_XML_TEMPLATE_CONFIG,
  payload
});

export const importDataSetTemplateSaveBlock = (payload) => ({
  type: IMPORT_DATA_SET_TEMPLATE_SAVE_BLOCK,
  payload
});


/**
 * Включение/выключение режима редактирования шаблона.
 * payload: { isEditing, id } — id хранит числовой идентификатор шаблона,
 * который будет обновлён (PUT) при повторном сохранении.
 */
export const importDataSetEditingTemplate = (payload) => ({
  type: IMPORT_DATA_SET_EDITING_TEMPLATE,
  payload
});

export const importDataFetchTemplates = () => async (dispatch) => {
  try {
    dispatch(importDataFetchTemplatesStart());
    const result = await get('/import/catalog-templates');
    dispatch(importDataFetchTemplatesSuccess(result?.data?.items || []));
  } catch (e) {
    dispatch(importDataTemplateOperationFail(e));
  }
};

export const importDataAddTemplate = (data, translations) => async (dispatch) => {
  try {
    await post('/import/catalog-templates', data);
    dispatch(importDataFetchTemplates());
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    dispatch(importDataTemplateOperationFail(e));
    return false;
  }
};

/**
 * Обновление существующего шаблона импорта (PUT).
 * Используется в режиме редактирования, чтобы не плодить дубликаты шаблонов.
 */
export const importDataUpdateTemplate = (id, data, translations) => async (dispatch) => {
  try {
    await put(`/import/catalog-templates/${id}`, data);
    dispatch(importDataFetchTemplates());
    Store.addNotification(COMMON_DATA_UPDATE_SUCCESS(translations));
    return true;
  } catch (e) {
    Store.addNotification(COMMON_DATA_UPDATE_FAIL(translations));
    dispatch(importDataTemplateOperationFail(e));
    return false;
  }
};

export const importDataDeleteTemplate = (id, translations) => async (dispatch) => {
  try {
    await remove(`/import/catalog-templates/${id}`);
    dispatch(importDataFetchTemplates());
    Store.addNotification(COMMON_DATA_DELETE_SUCCESS(translations));
  } catch (e) {
    Store.addNotification(COMMON_DATA_DELETE_FAIL(translations));
    dispatch(importDataTemplateOperationFail(e));
  }
};

export const stopDataImport = () => async () => {
  try {
    await clientApi2.post('/import/stop', {});
    return true;
  } catch (e) {
    return false;
  }
};
